export enum SliderType{
    MEGA = "MEGA_SLIDER", 
    SMALL = "SMALL_SLIDER"
}